module.exports = __webpack_public_path__ + "img/unasus.6ddd2a67.svg";